"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../utils/util");
function mergeOptions(target, source) {
    target.headers = target.headers || {};
    var headers = util_1.Util.extend(target.headers, source.headers);
    target = util_1.Util.extend(target, source);
    target.headers = headers;
}
exports.mergeOptions = mergeOptions;
function mergeHeaders(target, source) {
    if (typeof source !== "undefined" && source !== null) {
        var temp = new Request("", { headers: source });
        temp.headers.forEach(function (value, name) {
            target.append(name, value);
        });
    }
}
exports.mergeHeaders = mergeHeaders;



//////////////////
// WEBPACK FOOTER
// ./lib/net/utils.js
// module id = 10
// module chunks = 0